import img1 from "../Home/../assest/img1.avif";
import img2 from "../Home/../assest/card2.webp";
import img3 from "../Home/../assest/img3.jpg";
import img4 from "../Home/../assest/img4.jpg";
import img5 from "../Home/../assest/img5.jpg";
import img6 from "../Home/../assest/img6.jpg";
import img7 from "../Home/../assest/frames.webp";
import img8 from "../Home/../assest/img8.webp";

export const Cardinfo = [
    {
        id : 1,
        product:"Cup with photo",
        desc:"Personalised mug is printed with photos and text",
        img:img1
    },
    {
        id : 2,
        product:"Magic cup with photo",
        desc:"Colour-changing magic photo mugs for personal and professional gifting! ",
        img:img2
    },
    {
        id : 3,
        product:"Magic mirror with photo",
        desc:"Magical mirror gift will turn into an LED photo frame when it connects with battery or power. ",
        img:img3
    },  
    {
        id : 4,
        product:"Pillow with photo",
        desc:"Customised photo cushions to showcase your photo memories ",
        img:img4
    },
    {
        id : 5,
        product:"Key chain with photo",
        desc:"Keychains can be customized with your name and photos ",
        img:img5
    },
    {
        id : 6,
        product:"Shirt with photo",
        desc:"Photo Printed Tshirt Personalized for Men and Women ",
        img:img6
    },
    {
        id : 7,
        product:"Photo Frames",
        desc:" Custom Picture Frames for ideal gift options for all occasions",
        img:img7
    },
    {
        id : 8,
        product:"Wedding & All events shoot",
        desc:"Focused on the photography of events and activities relating to weddings. ",
        img:img8
    },
   ];